export default __webpack_public_path__ + "static/media/heart-red.1e9f32b7.svg";